import React from "react";
import { Box, Typography } from "@mui/material";

function Footer() {
  return (
    <Box sx={{ textAlign: "center", padding: "20px", backgroundColor: "#f5f5f5", marginTop: "40px", borderRadius: "10px" }}>
      <Typography variant="body2" sx={{ color: "#000000" }}>
        &copy; 2025 U&B Advocates
      </Typography>
      <Typography variant="body2" sx={{ color: "#000000" }}>
        <a href="https://altangerelg.github.io/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "#007bff" }}>
          Created by Altangerel
        </a>
      </Typography>
    </Box>
  );
}

export default Footer;